


document.addEventListener('DOMContentLoaded', function () {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch(...args);

    if (typeof args[0] === 'string' && args[0].includes('/cart/add.js')) {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);

            console.log('🛒 Total quantity in cart:', totalQuantity);

            // Update all cart-count elements
            document.querySelectorAll('.cart-count').forEach(el => {
              el.innerHTML = totalQuantity;
            });
          })
          .catch(err => console.error('Failed to fetch cart:', err));
      }, 300);
    }

    return response;
  };
});
















$(document).ready(function() {

   $('.cstm-testimonials-grid').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: false,
  centerPadding: '10px',
  autoplay: true,
  autoplaySpeed: 8000,
  slidesToScroll: 1,
  slidesToShow: 3,
      responsive: [
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        slidesToShow: 1
      }
    }
  ]

    });


    $('.main-announcment-bar-inner').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: false,
  centerPadding: '10px',
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToScroll: 1,
  slidesToShow: 1,
      responsive: [
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        slidesToShow: 1
      }
    }
  ]


    });



     $('#shopify-section-template--18042295419055__text_columns_images_AVz3gM .grid--layout').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: true,
  centerPadding: '10px',
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToScroll: 3,
  slidesToShow: 3,
      responsive: [
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        slidesToShow: 1
      }
    }
  ]

    });


  $('#shopify-section-template--18062146896047__text_columns_images_AVz3gM .grid--layout').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: true,
  centerPadding: '10px',
  autoplay: true,
  autoplaySpeed: 8000,
  slidesToScroll: 3,
  slidesToShow: 3,
      responsive: [
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        slidesToShow: 1
      }
    }
  ]

    });




  
  });






